import { useState, useEffect, useContext, useRef } from 'react';
import { Recorder, User } from 'type/type';
import styled from 'styled-components';
import { addHyphenMobile, createTempPassword, decryptAES256, deleteRecorderByIdx, encryptAES256, getRandomKey, getRecorderList, getUserList } from 'api/api';
import Pagenation from 'components/common/Pagenation';
import { calculMonthDateToString, formatDateToString, formattedDateTime } from 'pages/utils/commonUtils';
import hubLayout from 'styles/css/hubLayout.module.css';
import { useRecoilValue } from 'recoil';
import InCopyModal from 'components/common/InCopyModal';
import { isDarkAtom } from 'styles/atoms';
import { AdminLoginInfoContext, CommonTable, CommonTableWrap, FilterContentContainer } from 'pages/Layout';
import { JsonArray } from '@prisma/client/runtime/library';
import { PrimaryButton } from 'components/common/Button';
import { useSearchParams } from 'react-router-dom';

interface SearchInputType {
  id: string,
  name: string,
  mac: string,
  contract_no: string,
  is_contain: string,
  start_date: string,
  end_date: string,
  jisa_code: string[],
  page?: string,
};

const ScrollTable = styled.table`
  width: 100%;
  tbody.recorderTbody {
    display: block;
    background-color: rgb(60 85 110 / 50%);
    tr {
      &:hover {
        background-color: ${props => props.theme.recorderTableBodyTrHoverBgColor};
      }
      &:nth-child(1){
        font-weight: bold;
        background: ${props => props.theme.recorderTableHeadBgColor};
        &:hover {
          background-color: ${props => props.theme.recorderTableHeadBgColor};
        }
      }
      td, th {
        width: 100vh;
        font-size: 13px;
      }
      td {
        button {
          font-size: 13px;
          line-height: 20px;
          padding: 2px 0.2rem;
          width: 2.5rem;
        }
      }
    }
  }
  line-height: 15px;
`

function UserListCompnent({ idx, user, loading, getUsers, currentAuthCode, page }: { idx: number, user: User, loading: boolean, getUsers:Function, currentAuthCode: JsonArray, page: number }) {
  const REACT_APP_SECRET_KEY = process.env.REACT_APP_SECRET_KEY!;
  const REACT_APP_SECRET_IV = process.env.REACT_APP_SECRET_IV!;
  const [isShowRecorders, setIsShowRecorders] = useState(false);
  const [recorders, setRecorders] = useState<Recorder[]>([]);
  const [recorderIdx, setRecorderIdx] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const isDark = useRecoilValue(isDarkAtom);

  const showRecorderHandle = async () => {
    await getRecorderById();
  }

  const getRecorderById = async (chk?: string) => {
    const recorderRes = await getRecorderList(0, 0, { user_id: user.id });
    if (recorderRes.code === 200) {
      if (recorderRes.total_count) {
        setRecorders(recorderRes.data);
        setIsShowRecorders((prev) => !prev);
      } else {
        if (!chk) alert('장비가 없습니다.');
        setRecorders([]);
        setIsShowRecorders(false);
      }
    }
  };

  const openPopup = (url: string) => {
    // 팝업 window의 크기 지정
    let width = 500;
    let height = 850;

    if (url.includes("event") || url.includes("sub")) {
      width = 1600;
      height = 800;
    }

    // 팝업을 부모 브라우저의 정 중앙에 나열
    const left = window.screenX + (window.outerWidth - width) / 4;
    const top = window.screenY + (window.outerHeight - height) / 3;
    const windowFeatures = `width=${width},height=${height},left=${left},top=${top}`;

    // 팝업을 열고 window 속성 지정
    window.open(url, createTempPassword(), windowFeatures);
    window.parentCallBack = (code?: string) => {
      if (code === 'user') {
        getRecorderById('popup');
      } else if (code === 'recorder') {
        getRecorderById('popup');
      } else if (['userDel', 'userEdit'].includes(code || '')) {
        getUsers();
      }
    }
  };

  const openCgi = (recorder: Recorder) => {
    const { ip, tcp_port, id, password } = recorder;
    const decryptId = decryptAES256(id, REACT_APP_SECRET_KEY, REACT_APP_SECRET_IV);
    const decryptPwd = decryptAES256(password, REACT_APP_SECRET_KEY, REACT_APP_SECRET_IV);
    const data = `${decryptId}:${decryptPwd}`

    const randomKey = getRandomKey();
    const encryptData = encryptAES256(data, randomKey, decryptId.slice(0, 16));

    const url = `http://${ip}:${tcp_port}/cgi-bin/aslan_login.cgi?data1=${randomKey}${encodeURIComponent(encryptData)}`;

    window.open(url, '_blank');
  };

  const inCopyModal = (recorderIdx: number) => {
    if (!isOpen) {
      // 현재 모달이 열려 있지 않을 때만 히스토리 상태 추가
      window.history.pushState({ modalOpen: true }, '');
    }
    setIsOpen(true);
    setRecorderIdx(recorderIdx);
  };

  const deleteRecorder = async (recorderIdx: number) => {
    if(window.confirm("해당 장비를 삭제하시겠습니까?")){
      const recordersResponse = await deleteRecorderByIdx(recorderIdx);
      if (recordersResponse.code === 200) {
        alert('장비 삭제를 완료하였습니다.');
        getRecorderById("delete");
      } else {
        alert(recordersResponse.message);
      }
    }
  };

  function popWebViewer(recorder: Recorder) {
    if (recorder) {
      const hostname = window.location.hostname === "106.10.107.155" ? "106.10.107.155:13383" : window.location.hostname;
      const { mac, ip, tcp_port, id, password, in_ip, in_port, connect_type, ch } = recorder;
      const parameter = `?mac=${mac}&ip=${connect_type === 'DDNS' ? ip : in_ip}&port=${connect_type === 'DDNS' ? tcp_port : in_port}&id=${id}&password=${password}&channel=${ch.length}&currentChannel=0`;
      const AESparameter = encodeURIComponent(encryptAES256(parameter, REACT_APP_SECRET_KEY!, REACT_APP_SECRET_IV!));
      window.open(
        `http://${hostname}/admin/popup/viewer?recorderInfo=${AESparameter}`,
        'webViewer',
        'width=1550,height=890,top=100,left=200,noopener,noreferrer'
      );
    }
  }

  const isOver3Hours = (targetStrTime: string): boolean => {
    const targetTime = new Date(targetStrTime).getTime();         // 밀리초
    const now = new Date().getTime();                             // 현재 시간 밀리초
    const diffInHours = Math.abs(now - targetTime) / (1000 * 60 * 60); // 시간 단위 차이
    return diffInHours >= 3;
  };
  useEffect(() => {
    setIsShowRecorders(false);
  }, [loading]);
  return (
    <>
      <tr>
        <td className='w-5'>{(page - 1) * 10 + idx + 1}</td>
        <td className='w-5'>{user.id}</td>
        <td className='w-10 ellipsis-text'>{user.name}</td>
        {/* <td className='w-10 ellipsis-text'>{maskMobile(decryptAES256(user.mobile, REACT_APP_SECRET_KEY!, REACT_APP_SECRET_IV!))}</td> */}
        <td className='w-10 ellipsis-text'>{addHyphenMobile(decryptAES256(user.mobile, REACT_APP_SECRET_KEY!, REACT_APP_SECRET_IV!))}</td>
        <td className='w-20 ellipsis-text'>{user.email}</td>
        <td className='w-15 ellipsis-text'>{user.address}</td>
        <td className='w-15 ellipsis-text'>{formattedDateTime(user.create_date!)}</td>
        <td className='w-15 ellipsis-text'>{user.last_login_date ? formattedDateTime(user.last_login_date) : ''}</td>
        <td className='w-10'>
          <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => openPopup(`/admin/popup/user/sub/list/${user.id}?isDark=${isDark}`)}>보기</button>
        </td>
        <td className='w-10'>
          <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => openPopup(`/admin/popup/user/edit/${user.id}?isDark=${isDark}`)}>수정</button>
        </td>
        {currentAuthCode.includes('B') && 
          <td className='w-10'>
            <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => showRecorderHandle()}>보기</button>
          </td>
        }
      </tr>
      {isShowRecorders &&
        <tr>
          <td colSpan={currentAuthCode.includes('B') ? 11 : 10} style={{ border: '0' }}>
            <ScrollTable>
              <tbody className='recorderTbody'>
                <tr>
                  <td className='w-5'>No</td>
                  <td className='w-10'>MAC</td>
                  <td className='w-10'>계약번호</td>
                  <td className='w-15'>설치위치</td>
                  <td className='w-10'>IP/PORT</td>
                  <td className='w-5'>접속방식</td>
                  <td className='w-10'>헬스상태</td>
                  <td className='w-5'>펌웨어버전</td>
                  <td className='w-10'>생성일자</td>
                  <td className='w-30'>장비관리</td>
                </tr>
                {recorders.map((recorder, idx) => 
                  <tr key={`recorder_${idx}`}>
                    <td>{ idx + 1 }</td>
                    <td>
                      <div>{ recorder.mac }</div>
                      <div>({ recorder.model })</div>
                    </td>
                    <td>{ recorder.contract_no }</td>
                    <td>{ recorder.reg_name }</td>
                    <td>
                      <div>{ recorder.connect_type === "DDNS" ? `${recorder.ip}:${recorder.tcp_port}` : `${recorder.in_ip}:${recorder.in_port}` }</div>
                      <div style={{ color: `${isOver3Hours(formattedDateTime(recorder.uptime)) ? 'red' : ''}` }}>({ formattedDateTime(recorder.uptime) })</div>
                    </td>
                    <td>{ recorder.connect_type }</td>
                    <td>
                      <p>HDD:{ recorder.hdd_status ? 'Normal' : 'Error' }</p>
                      <p>Channel:{ recorder.ch }</p>
                    </td>
                    <td>{ recorder.fw_ver }</td>
                    <td>{ formattedDateTime(recorder.create_date).slice(0, 10) }</td>
                    <td>
                      <div className={`${hubLayout.btn_group}`} style={{ margin: '0' }}>
                        <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => popWebViewer(recorder)}>접속</button>
                        <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.pink}`} onClick={() => openPopup(`/admin/popup/recorder/edit/${recorder.idx}?isDark=${isDark}`)}>수정</button>
                        <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => deleteRecorder(recorder.idx)}>삭제</button>
                        {!recorder.is_copy &&
                          <>
                            <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.pink}`} onClick={() => inCopyModal(recorder.idx)}>복사</button>
                            <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => openPopup(`/admin/popup/recorder/replace/${recorder.idx}?isDark=${isDark}`)}>교체</button>
                          </>
                        }
                        <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.pink}`} onClick={() => openPopup(`/admin/popup/recorder/event/${recorder.mac}?isDark=${isDark}`)}>이벤트</button>
                        <button type="button" className={`${hubLayout.btn} ${hubLayout.medium} ${hubLayout.blue}`} onClick={() => openCgi(recorder)}>cgi접속</button>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </ScrollTable>
          </td>
        </tr>
      }
      {isOpen &&
        <InCopyModal isOpen={isOpen} setIsOpen={setIsOpen} recorderIdx={recorderIdx} onConfirm={getRecorderById}/>
      }
    </>
  );
}

function UserList() {
  const isFirstRender = useRef(true);
  const [searchParams, setSearchParams] = useSearchParams();
  const { adminLoginInfo } = useContext(AdminLoginInfoContext);
  const currentAuthCode = Array.isArray(adminLoginInfo.auth_code) ? adminLoginInfo.auth_code : []; // 배열로 변환
  const [users, setUsers] = useState<User[]>([]);
  // 페이지네이션
  const buttonPerPage = 10; // 보여줄 페이지네이션 버튼 수
  const [page, setPage] = useState(1); // 현재 페이지
  const [limit] = useState(10); // 보여줄 게시물 개수
  const [totalCount, setTotalCount] = useState(-1);
  const numPages = Math.ceil(totalCount / limit); // 총 페이지 수
  const [startButtonNum, setStartButtonNum] = useState(1); // 버튼 시작 숫자
  const [loading, setLoading] = useState(true); // 보여줄 게시물 개수

  // 필터obj
  const [searchObj, setSearchObj] = useState<SearchInputType>({
    contract_no: searchParams.get("contract_no") || "",
    name: searchParams.get("name") || "",
    id: searchParams.get("id") || "",
    mac: searchParams.get("mac") || "",
    is_contain: '1',
    start_date: searchParams.get("start_date") || calculMonthDateToString(new Date(), -3),
    end_date: searchParams.get("end_date") || formatDateToString(new Date()),
    page: searchParams.get("page") ? String(searchParams.get("page")) : undefined,
    jisa_code: Array.isArray(adminLoginInfo.jisa_code)
      ? (adminLoginInfo.jisa_code as string[])
      : typeof adminLoginInfo.jisa_code === "string"
      ? [adminLoginInfo.jisa_code] // 문자열이면 배열로 변환
      : [],
  });
  // 페이지네이션 버튼 클릭 시
  const isClickButton = (str:string) => {
    if (str === 'prev') handlePrevPage();
    else handleNextPage();
  };

  // 이전페이지 이동(buttonPerPage만큼 -)
  const handlePrevPage = () => {
    const prevPage = Math.max(startButtonNum - buttonPerPage, 1);
    setStartButtonNum(prevPage);
    setPage(prevPage);
  };

  // 다음페이지 이동(buttonPerPage만큼 +)
  const handleNextPage = () => {
    const nextPage = Math.min(startButtonNum + buttonPerPage, numPages);
    setStartButtonNum(nextPage);
    setPage(nextPage);
  };

  const handleKeyDown = async (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') searchHandle();
  }

  const searchHandle = () => {
    page === 1 ? getUsers(page, limit) : setPage(1);
  }

  // 검색 날짜 변경
  const handleSearchDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === "search_start_date") setSearchObj(prev => ({ ...prev, start_date: value }));
    else setSearchObj(prev => ({...prev, end_date: value}));
  };

  const getUsers = async (pagePram: number, limitPram: number) => {
    setLoading(true);
    const { contract_no, name, id, mac, is_contain, jisa_code, start_date, end_date } = searchObj;
    const userRes = await getUserList(pagePram | page, limitPram | limit, searchObj);
    if (userRes.code === 200) {
      setUsers(userRes.data);
      setTotalCount(userRes.total_count);
    }
    setSearchParams({ contract_no, name, id, mac, is_contain, jisa_code, start_date, end_date, page: String(page) });
    setLoading(false);
  };
  // 검색 value 변경
  const handleSearchValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setSearchObj(prev => ({
      ...prev,
      [name]: name === 'id' ? value.toLowerCase() : value,
    }));
    setSearchObj(prev => ({...prev, value}));
  };
  
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      const hasParams = searchParams.toString() !== "";
      if (!hasParams) return; // ❌ 파라미터 없으면 첫 렌더 스킵
    }
    getUsers(page, limit); // ✅ 이후에는 무조건 실행
  }, [page, limit]);
  return (
    <>
      <FilterContentContainer>
        <div className='flex-row'>
          <input type="text" name="id" onChange={handleSearchValue} value={searchObj.id} placeholder="ID 입력" onKeyUp={handleKeyDown} style={{ width: "10rem" }} />
          <input type="text" name="name" onChange={handleSearchValue} value={searchObj.name} placeholder="이름 입력" onKeyUp={handleKeyDown} style={{ width: "10rem" }} />
          <input type="text" name="mac" onChange={handleSearchValue} value={searchObj.mac} placeholder="MAC 입력" onKeyUp={handleKeyDown} style={{ width: "10rem" }} />
          <input type="text" name="contract_no" onChange={handleSearchValue} value={searchObj.contract_no} placeholder="계약번호 입력" onKeyUp={handleKeyDown} style={{ width: "10rem" }} />
          <label>가입일</label>
          <div className='flex-row'>
            <input type='date' name='search_start_date' value={searchObj.start_date} onChange={handleSearchDate} />
            <span>~</span>
            <input type='date' name='search_end_date' value={searchObj.end_date} onChange={handleSearchDate} />
          </div>
        </div>
        <PrimaryButton type="button" onClick={searchHandle}>조회</PrimaryButton>
      </FilterContentContainer>
      <div>
        검색 결과: <span style={{ fontWeight: "600" }}>{totalCount < 0 ? 0 : totalCount}</span>건
      </div>
      <CommonTableWrap>
        <CommonTable>
          <thead>
            <tr>
              <th className='w-5'>No</th>
              <th className='w-10'>ID</th>
              <th className='w-10'>고객명</th>
              <th className='w-10'>연락처</th>
              <th className='w-15'>E-MAIL</th>
              <th className='w-20'>주소</th>
              <th className='w-10'>가입 일자</th>
              <th className='w-10'>최근 로그인 일자</th>
              <th className='w-10'>부계정</th>
              <th className='w-10'>회원정보</th>
              {currentAuthCode.includes('B') && <th className='w-10'>장비정보</th>}
            </tr>
          </thead>
          <tbody>
            {totalCount === 0 ?
              <tr>
                <td colSpan={currentAuthCode.includes('B') ? 11 : 10}>검색결과가 없습니다.</td>
              </tr>
              :
              users.map((user, idx) => (
                <UserListCompnent key={`user_list_${idx}`} user={user} idx={idx} loading={loading} getUsers={getUsers} currentAuthCode={currentAuthCode} page={page} />
              ))
            }
          </tbody>
        </CommonTable>
      </CommonTableWrap>
      <Pagenation
        totalCount={totalCount}
        total={numPages}
        limit={limit}
        page={page}
        setPage={setPage}
        startButtonNum={startButtonNum}
        setClickButton={isClickButton}
      />
    </>
  );
}

export default UserList;